import { gql } from '@apollo/client';

export const breakingNewsVariables = (channelId: string) => {
  return {
    sort: '-isPinned,-createdAt',
    where: {
      channel: {
        equals: channelId,
      },
      status: {
        in: ['published', 'changed'],
      },
    },
  };
};

export const GET_BREAKING_NEWS = gql`
  query GetBreakingNews($where: BreakingNew_where, $limit: Int, $sort: String) {
    BreakingNews(where: $where, limit: $limit, sort: $sort) {
      docs {
        id
        title
        description
        twitterId
        updatedAt
        isPinned
        topics {
          title
          updatedAt
        }
      }
      hasNextPage
      hasPrevPage
      limit
      offset
      page
      pagingCounter
      totalDocs
      totalPages
    }
  }
`;

export const GET_BREAKING_NEW_RECORDS = gql`
  query GetBreakingNews($where: BreakingNew_where, $limit: Int) {
    BreakingNewsRecords(where: $where, limit: $limit) {
      docs {
        id
        date
        title
        description
        twitterId
        content {
          title
          description
          slug
          type
          subType
          readingTime {
            text
            minutes
          }
        }
      }
      hasNextPage
      hasPrevPage
      limit
      offset
      page
      pagingCounter
      totalDocs
      totalPages
    }
  }
`;
